<template>
  <div :class="$vuetify.breakpoint.xsOnly ? 'px-4' : ''">
    <v-card :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" class="mb-4">
      <v-card-title class="subtitle-1 text-uppercase font-weight-medium d-flex align-center">
        <v-icon class="mr-2">mdi-paperclip</v-icon>
        {{ $t('quotations.tabs.attachments') }}
      </v-card-title>
      <v-card-text>
        <offer-files :offer-id="quotation.id" />
      </v-card-text>
    </v-card>
    <v-alert type="info" text dense>{{ $t('quotations.attachments.info') }}</v-alert>
  </div>
</template>

<script>
import OfferFiles from '@/components/Offers/OfferFiles';

export default {
  name: 'QuotationAttachmentsTab',
  components: { OfferFiles },
  props: {
    quotation: { type: Object, required: true },
  },
};
</script>
